import React from 'react';
import {designSystemToken, Icon} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import type {GigBriefData} from '../shell/informationTypes';
import BriefSection from './BriefSection';
import styles from './BriefBlocks.module.scss';

interface PreferredCreatorCardProps {
  preferredCreator: GigBriefData['preferredCreator'];
  creatorIsInTheZone: boolean;
}

function PreferredCreatorCard({
  preferredCreator,
  creatorIsInTheZone,
}: PreferredCreatorCardProps) {
  const {gender, age, location, specialty, capability} = preferredCreator;
  const ageGender = [gender, age].filter(Boolean).join(', ');

  if (!ageGender && !location && !specialty && !capability) {
    return null;
  }

  return (
    <BriefSection
      testID="brief-preferred-creator"
      title={translate('Am I a good fit?')}
      subtitle={translate(
        'The brand is looking for creators that fit this profile:'
      )}
    >
      <div className={styles.requirements}>
        {ageGender ? (
          <div className={styles.requirement} data-testid="brief-age-gender">
            {ageGender}
          </div>
        ) : null}
        {location ? (
          <div className={styles.requirement} data-testid="brief-location">
            <span>{location}</span>
            {!creatorIsInTheZone && (
              <span
                className={styles.locationWarning}
                data-testid="brief-location-warning"
                title={translate(
                  'The brand is looking for creators in a different location than you.'
                )}
              >
                <Icon
                  size="small"
                  appearance="neutral"
                  name="Actions-Alert-Line"
                  color={designSystemToken('semantic.fg.warning')}
                />
              </span>
            )}
          </div>
        ) : null}
        {specialty ? (
          <div className={styles.requirement} data-testid="brief-specialty">
            <span className={styles.requirementLabel}>
              {translate('Specializing in:')}
            </span>
            <span>{specialty}</span>
          </div>
        ) : null}
        {capability ? (
          <div className={styles.requirement} data-testid="brief-capability">
            <span className={styles.requirementLabel}>
              {translate('With Capabilities:')}
            </span>
            <span>{capability}</span>
          </div>
        ) : null}
      </div>
    </BriefSection>
  );
}

export default PreferredCreatorCard;
